import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthCheck } from '../auth/auth.check';
import { AccountManagementComponent } from './account-management/account-management.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import { ProfileComponent } from './profile/profile.component';
import { RedactionComponent } from './redaction/redaction.component';
import { RcComponent } from './rc/rc.component';

const routes: Routes = [

  {path: "Reusable-component", component: RcComponent,canActivate: [AuthCheck]},
  {path: 'Dashboard', component: DashboardComponent,canActivate: [AuthCheck]},
  {path : "Account-management", component: AccountManagementComponent, canActivate: [AuthCheck]},
  {path: "profile", component: ProfileComponent , canActivate: [AuthCheck]},
  {path: "redaction", component: RedactionComponent, canActivate: [AuthCheck]},
  ];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }
